import React, { Component } from 'react';
import AccountCircle from 'material-ui/svg-icons/action/account-circle';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { FormattedMessage, intlShape } from 'react-intl';

const localeMessages = {
  cancel: {
    id: 'Supporter.ConfirmDelete.Cancel',
    defaultMessage: 'Abbrechen'
  },
  delete: {
    id: 'Supporter.ConfirmDelete.Delete',
    defaultMessage: 'Löschen'
  }
};


class ConfirmContactDeleteDialog extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    const actions = [
      <FlatButton
        label={this.context.intl.formatMessage(localeMessages.cancel)}
        onClick={this.props.onClose}
      />,
      <FlatButton
        label={this.context.intl.formatMessage(localeMessages.delete)}
        primary={true}
        style={{color: "red"}}
        onClick={this.props.onDelete}
      />
    ];

    return (
      <Dialog
        actions={actions}
        onRequestClose={this.props.onClose}
        title={<div>
          <Avatar
            icon={<AccountCircle />}
            size={36}
            style={{marginRight:'15px '}}
          />
          <span>
            <FormattedMessage
              id="Supporter.ConfirmDelete.DeleteContact"
              values={{
                name: this.props.contact.name
              }}
              defaultMessage="Soll der Kontakt {name} dauerhaft gelöscht werden?"
            />
          </span>
        </div>}
        open={true}
      >
      </Dialog>
    );
  }
};

export default ConfirmContactDeleteDialog;


// WEBPACK FOOTER //
// ./src/ConfirmContactDeleteDialog.js